import React from "react";
import { Save } from "lucide-react";

interface SaveButtonProps {
  saving: boolean;
  onSaveMeme: () => void;
}

const SaveButton: React.FC<SaveButtonProps> = ({ saving, onSaveMeme }) => {
  return (
    <div className="border-t border-gray-200 pt-6">
      <button
        onClick={onSaveMeme}
        disabled={saving}
        className="w-full px-6 py-4 text-white bg-gradient-to-r from-green-500 to-green-600 rounded-lg hover:from-green-600 hover:to-green-700 transition-all duration-200 transform hover:scale-105 disabled:opacity-50 disabled:transform-none flex items-center justify-center space-x-2 font-bold text-lg"
      >
        {saving ? (
          <>
            <div className="animate-spin rounded-full h-5 w-5 border-b-2 border-white"></div>
            <span>שומר...</span>
          </>
        ) : (
          <>
            <span dir="rtl">שלח!</span>
            <Save className="h-5 w-5" />
          </>
        )}
      </button>
    </div>
  );
};

export default SaveButton;
